module.exports = __webpack_public_path__ + "img/suit-06.a53d2988.png";